import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { AssetsToSellFromPP } from "../../Store/PPToProductInstructionStatic";
import { PropositionInvestmentConfig } from "../../../../../../../Wrap/Models/Domains/Account/PropositionInvestmentConfig";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { SelectedInvestmentStore } from "../../../../../../Shared/IST/Store/Variable";
import { ActionType } from "../../../../../../../react-core/Flux/ActionType";
import { SectionHeader } from "../../../Common/SharedComponents";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { SearchTabs } from "../../../../../../Shared/IST/Components/Shared/SearchTabs";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { InvestmentSelectionAction } from "../../../../../../Shared/IST/Action/InvestmentSelectionAction";
import { CompanyWizardAction } from "../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { ProductAllocation } from "../../../../../../../Wrap/Models/Domains/Transfer/Gia/ProductAllocation";
import { PPToProductLables } from "../../Resource/Contents";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { PPtoProductBuyAllocationTable } from "./PPtoProductBuyAllocationTable";
import { PPToProductAction } from "../../Actions/PPToProductActions";
import { Instrument } from "../../../../../../../Wrap/Models/Domains/Investment/Instrument";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { ReuseInvesment } from "../../../../../../Shared/IST/Components/ReuseInvesment";
import { reuseType } from "../../../../../../Shared/IST/Resource/Content";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { AccountAdviceType } from "../../../../../../../Wrap/Constants/Enums/Apply/AccountAdviceType";
import { DecisionMaker } from "../../../../../../Shared/IST/Components/DecisionMaker";
import { initInstrumentSelection } from "../../../../../../Shared/IST/Components/Shared/Utils";
import { QuoteAndApplyBaseModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/QuoteAndApplyBaseModel";

interface IPPtoProductBuyAllocationProps extends IProcessComponentProps {
    data: ProductAllocation[];
    sellToSubaccountType: SubAccountType;
    totalValue: number;
    clientAccount:ClientAccount;
    existingAssets:AssetsToSellFromPP[];
    targetAllocations: AssetsToSellFromPP[];
    onTreasuredAssetChange: Function;
    checkTreasuredAsset: Array<number>;
    toAbrdnSIPP: boolean;
    contributionBase:any;
    onDecisionMakerChange: (v) => void;
    modelData: QuoteAndApplyBaseModel;
}

interface IPPtoProductBuyAllocationState {
    allocationAssetsTable: AssetsToSellFromPP[];
    isLoading: boolean;
    treasuredAssetProductIds: Array<number>;
    investmenPermission: PropositionInvestmentConfig[];
    companyServicePropostion: ServiceProposition[];
    applyEvenWeight: boolean;
    reuseType: reuseType;
}

export class PPtoProductBuyAllocation extends ProcessComponent<IPPtoProductBuyAllocationProps, IPPtoProductBuyAllocationState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            allocationAssetsTable:[],
            treasuredAssetProductIds: null,
            investmenPermission: [],
            companyServicePropostion: [],
            applyEvenWeight: false,
            reuseType: reuseType.no,
        };

        this.subscribeToStore(SelectedInvestmentStore, () => this.onStoreChange());
    }

    onStoreChange() {
        if (SelectedInvestmentStore.getActionType() == ActionType.Success) {
            
            const data = SelectedInvestmentStore.getData();
            if (!data) return;

            const allocationAssetsTable: AssetsToSellFromPP[] = this.state.allocationAssetsTable.concat();

            const insAdd = data.filter((item) =>
                allocationAssetsTable.every(
                    (ele) =>
                        ele.ProductId !== item.Instrument.ProductId
                )
            );
            if (insAdd.length > 0) {
                const newItem = this.transformNewItem(insAdd);
                this.setState({ allocationAssetsTable: allocationAssetsTable.concat(newItem) });
            }       
        } else if (SelectedInvestmentStore.getActionType() == ActionType.Replace) {

            const data = SelectedInvestmentStore.getData();
            if (!data) return;

            let cash = data.filter((ele) => ele.Instrument.ProductId === this.props.modelData.CashInstrument.ProductId);
            cash = [this.transformCashInstrument(cash.length > 0 ? cash[0]?.Instrument : this.props.modelData.CashInstrument)];

            let allocation = this.transformNewItem(data);

            allocation = cash.concat(
                allocation.filter((ele) => ele.ProductId !== this.props.modelData.CashInstrument.ProductId)
            );

            this.setState({ allocationAssetsTable: allocation });

            const productIds = allocation.map((ele) => ele.ProductId);
            this.onReplaceInvestmentUpdateProps(productIds);
        }
    }

    private onDeleteInvestmentUpdateState = (changes, productId) => {
        const _data: any[] = this.state.allocationAssetsTable.concat();
        const index = _data.findIndex((ele) => ele.ProductId == productId);
        if (index < 0) return _data;
        if (changes == -1) {
            _data.splice(index, 1);
        } else {
            const obj = _data[index];
            for (const key in changes) {
                obj[key] = changes[key];
            }
            _data[index] = obj;
        }
        this.setState({ allocationAssetsTable: _data });
    };

    private onDeleteInvestmentUpdateProps = (productId) => {
        const _data: any[] = (this.props.data ?? []).concat();
        const index = _data.findIndex((ele) => ele.ProductId == productId);
        if (index < 0) return _data;
        _data.splice(index, 1);
        
        this.props.onChange({ BuyAllocations: _data });
    };

    private onReplaceInvestmentUpdateProps = (productIds) => {
        let _data: any[] = (this.props.data ?? []).concat();
        _data = _data.filter((ele) => productIds?.includes(ele.ProductId));

        this.props.onChange({ BuyAllocations: _data });
    };

    private transformNewItem = (investments): AssetsToSellFromPP[] => {
        return investments.map((ele) => {
            return {
                ProductId: ele.Instrument.ProductId,
                ProductCode: ele.Instrument.ProductCode,
                AssetName: ele.Instrument.Name,
                ProductType: ele.Instrument.Type,
            };
        });
    };

    private transformCashInstrument = (investment): AssetsToSellFromPP => {
        return {
            ProductId: investment.ProductId,
            ProductCode: investment.ProductCode,
            AssetName: investment.Name,
            ProductType: investment.Type,
            DisinvestAll: false,
        };
    };

    private getSectionHeader()
    {
        let str=PPToProductLables.investmentsToBuyIn;
        switch(this.props.sellToSubaccountType) {
            case SubAccountType.StocksIsa:
                return str+"ISA"
            case SubAccountType.Npr:
                return str+"Aberdeen SIPP"
            default:
                return PPToProductLables.investmentsToBuy;
          }
    }

    private displayDecisionMaker(allocationAssets: AssetsToSellFromPP[], buyAllocations: ProductAllocation[]) {
        return allocationAssets
            .filter(asset => [ProductType.Equity, ProductType.Bond].includes(asset.ProductType))
            .some(asset => buyAllocations.some(allocation => allocation.ProductId == asset.ProductId && (allocation.Percentage > 0 || allocation.Quantity > 0)));
    }

    private onReuseInvestment(v) {
        this.setState({ reuseType: v });
        if (v == reuseType.no) {
            this.setState({ allocationAssetsTable: [this.transformCashInstrument(this.props.modelData.CashInstrument)] });
            this.props.onChange({ BuyAllocations: [] });
        }
        else if(v== reuseType.useCurrentAssets)
        {
            this.setState({ allocationAssetsTable: this.props.existingAssets });
            this.props.onChange({ BuyAllocations: [] });
        }
        else if (v== reuseType.useTargetAllocation)
        {
            this.setState({ allocationAssetsTable: this.props.targetAllocations });
            this.props.onChange({ BuyAllocations: this.getBuyAllocationProps(this.props.targetAllocations)});
        }
    }

    private getBuyAllocationProps(targetAllocations: Array<AssetsToSellFromPP>): ProductAllocation[] {
        return targetAllocations.map((ele) => {
            return {
                ProductId: ele.ProductId,
                Percentage: ele.Weighting
            }
        })
    }

    public render(): JSX.Element {
        const { data, onChange, totalValue, clientAccount, contributionBase, onDecisionMakerChange } = this.props;
        const params = getQueryParameters();
        return (
            <div>
                {SectionHeader(this.getSectionHeader())} 
                
                {(
                    <div className="ist-wrap">
                        <PartLoading isLoading={this.state.isLoading}>
                        <ReuseInvesment
                        isReview={RestrictionStore.buyDisabled()}
                        onReuseInvesment={(v) => {
                            this.onReuseInvestment(v);
                        }}
                        data={data}
                        onChange={onChange}
                        onRef={(ref) => this.appendChild(ref)}
                        />
                        <SearchTabs
                            hiercharyId={params["subaccounthierarchyid"]}
                            product={this.props.toAbrdnSIPP ? SubAccountType.Npr : SubAccountType.StocksIsa}
                            data={data}
                            isUnderTransfer={false}
                            investmentPermission={this.state.investmenPermission}
                            accountServiceProposition={clientAccount?.AccountServicePropositionId}
                            canBeBought={true}
                            canBeSold={false}
                            companyServiceProposition={this.state.companyServicePropostion}
                        />
                        </PartLoading>
                        <h3 className="mb-0">Allocation</h3>
                        <PPtoProductBuyAllocationTable 
                                data={data || []}
                                tableData={this.state.allocationAssetsTable}
                                totalValue={totalValue}
                                onRef={(ref) => this.appendChild(ref)}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                onChange={(v) =>  onChange({ BuyAllocations: v})}
                                onTableDataDelete={(changes, productId)=>{
                                    this.onDeleteInvestmentUpdateState(changes, productId);
                                    this.onDeleteInvestmentUpdateProps(productId);
                                }}
                                onTreasuredAssetChange={this.props.onTreasuredAssetChange}
                                checkTreasuredAsset={this.props.checkTreasuredAsset}
                        />
                        {(this.displayDecisionMaker(this.state.allocationAssetsTable ?? [], data) &&
                            <DecisionMaker
                                onRef={(ref) => this.appendChild(ref)}
                                data={contributionBase}
                                onChange={(v) => {
                                    onDecisionMakerChange(v);
                                }}
                                clAccountId={getQueryParameters()["claccountid"]}
                                headAccountHierarchyId={clientAccount?.HierarchyId}
                                companyCode={clientAccount?.Company}
                                accountAdviceType={
                                    clientAccount?.Discretionary
                                        ? AccountAdviceType.Discretionary
                                        : AccountAdviceType.NonDiscretionary
                                }
                            />
                            )}
                    </div>
                )}
            </div>
        );
    }

    componentDidMount() {
        super.componentDidMount();
        const {clientAccount} =this.props;
        if (clientAccount?.AccountServicePropositionId) {
            InvestmentSelectionAction.getInvestmentPermission(clientAccount.AccountServicePropositionId, (res) => {
                this.setState({ investmenPermission: res });
            });
        }
        if (clientAccount?.Company) {
            CompanyWizardAction.getViewCompany(clientAccount?.Company, (res) => {
                this.setState({ companyServicePropostion: res?.ServicePropositions });
            });
        }
        if(this.props.data&&this.props.data.length>0)
        {
            this.loadExistingInvestmentAllocationData(this.props.data);
        }
        this.onReuseInvestment(reuseType.no);
    }

    componentWillUpdate(nextProps: any, nextStat: any): void {
        if (!isNullOrEmpty(nextProps.existingAssets) && isNullOrEmpty(this.props.existingAssets) && isNullOrEmpty(this.state.allocationAssetsTable) && isNullOrEmpty(nextStat.allocationAssetsTable)) {
            this.setState({ allocationAssetsTable: nextProps.existingAssets.filter(x=>x.ProductType==ProductType.Cash) }); //ReuseInvestment default is no, when no, only cash instrument is displayed
        }
    }

    private loadExistingInvestmentAllocationData(buyAllocations: ProductAllocation[]) {+
        PPToProductAction.getAllocationAssetDetails(buyAllocations, [],
            (result, buyAllocations, sellAllocations) => {
                this.setState({
                    allocationAssetsTable: this.transformToAsetsToSellFromPP(result, buyAllocations),
                });
            });
    }

    private transformToAsetsToSellFromPP(instruments: Instrument[], allocations: ProductAllocation[]): AssetsToSellFromPP[] {
        if (instruments.length == 0) return [];
        let transformAsetsToSellFromPP: AssetsToSellFromPP[] = [];
        allocations.forEach((x) => {
            var instrument= instruments.find(y => y.ProductId == x.ProductId);
            if(instrument)
            {
                let asset: AssetsToSellFromPP = {
                    ProductId: x.ProductId,
                    ProductCode: instrument.ProductCode,
                    AssetName: instrument.Name,
                    ProductType: instrument.Type,
                    DisinvestAll: x.Percentage == 100
                };
                transformAsetsToSellFromPP.push(asset);
            }
        });
        return transformAsetsToSellFromPP;
    }

    isValid() {
        if (RestrictionStore.buyDisabled() || RestrictionStore.sellDisabled()) return false;
        return super.isValid();
    }
}
